<template>
	<div class="centerWidth">
		<div class="gaokao">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>{{dataInfo.Name}}</span>
			</div>
			<section class="gaokao-content">
				<div class="my-title">{{dataInfo.Title}}</div>
				<div class="gaokao-con fwbhtml" v-html="dataInfo.Description">
				</div>
				<div class="gaokao-notice">
					<!--  v-html="dataInfo.Notice" -->
					<p class="gk-notice-tit" style="color: #ff0000;">测试前须知</p>
					<ul class="gk-notice-li">
						li>1、请务必诚实、独立地回答问题，只有如此，才能得到有效的结果。</li>

						<li>2、每一题目请以第一印象作答，不必仔细推敲，答案没有好坏、对错之分，根据自己的实际情况做答。</li>

						<li>3、本报告给广大考生和家长提供了一种科学的方法，一份可靠的依据，从而让考生和家长能了解和接触更多的可能，而并非限制学生的选择。</li>

						<li>5、所有测评结果的得分仅代表学生本人各种指标之间的相对水平，而不代表考生的这些指标在人群总体中的绝对水平。</li>

						<li>6、只要你是认真、真实地填写了测试问卷，那么通常情况下你都能得到确实和你相匹配的结果。希望你能从中或多或少地获得一些有益的信息。</li>
					</ul>
				</div>
				<button class="gaokao-btn" @click="goTesta()">开始测试</button>
			</section>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: 0,
				dataInfo: {},
				key: ''
			};
		},
		mounted() {
			var id = this.$route.query.id || 0;
			var key = this.$route.query.key || '';
			if (id) {
				this.id = id;
				this.key = key;
				this.GetCardFeature();
			} else {
				this.$message.error('网络错误');
				setTimeout(() => {
					this.$router.go(-1);
				}, 1000);
			}
		},
		methods: {
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},
			// 测试
			goTesta() {
				this.$router.push({
					path: '/jthomeJiaTingEnd',
					query: {
						id: this.id,
						key: this.key
					}
				});
			},
			GetCardFeature() {
				var that = this;
				that.$newapi.HtppRequest(
					'Evaluation/' + that.id + '?key=' + that.key,
					'GET', {},
					function(res) {
						console.log('获取详情', res);
						if (res.code === 0) {
							var Info = res.data;
							that.dataInfo = Info;
						}
					},
					function(err) {
						console.log(err);
					});
			}
		}
	};
</script>

<style scoped>
	.gaokao {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
	}

	.gaokao-con {
		padding: 50px 20px;
		height: auto;
		overflow: hidden;
	}

	.gaokao-con p {
		font-size: 14px;
		color: #333;
		text-indent: 2em;
		line-height: 28px;
	}

	/* gaokao-notice */
	.gaokao-notice {
		width: 100%;
		padding: 0 40px 40px 40px;
		height: auto;
		overflow: hidden;
		background-color: #eee;
	}

	.gk-notice-tit {
		font-size: 17px;
		color: #333;
		padding: 40px 0;
	}

	.gk-notice-li {
		width: 100%;
		height: auto;
		overflow: hidden;
	}

	.gk-notice-li li {
		font-size: 15px;
		color: #333;
		padding-bottom: 15px;
	}

	.gk-notice-li li:last-child {
		padding-bottom: 0px;
	}

	.gaokao-btn {
		width: 200px;
		height: 40px;
		background-color: #333;
		border-radius: 6px;
		font-size: 16px;
		color: #fff;
		line-height: 40px;
		margin: 50px auto;
		display: block;
	}
</style>
